import React from 'react'

import { Link } from 'react-router-dom';

const StudentRegistration = () => {

    

    return (
        <>
            <marquee behavior="scroll" scrollamount={14} bgcolor="#fdc800" style={{ paddingTop: 5, paddingBottom: 5 }}>
                <span style={{ fontSize: 25 }}>"भारत में पहिली बार Online Study Center कि शुरवात कि गई है डायरेक्ट ऑनलाइन एडमिशन और ऑनलाइन परीक्षा पूरी जानकारी के लिए निचे दिए गए सूचनाओं को देखे | India's First Online Study Center | Apply Direct Online Admission and Exam</span>
            </marquee>

            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 col-md-6'>
                        <div className='course-inner-details pt-3'>
                            <h2 className='title-default-left title-bar-high'>Welcome To Online Courses
                            </h2>
                            <h3 className='sidebar-title'>ITT Council Start Self Study Facility</h3>
                            <ul className='learning-outcomes'>
                                <li>Self Study Center.</li>
                                <li>Direct Online Student Admission.</li>
                                <li>Online Study Center Facility.</li>
                                <li>Blog Self Study and Notes Facility.</li>
                                <li>Online Exam Facility.</li>
                                <li>Instant Result.</li>
                                <li>Certificate Soft Copy by eMail.</li>
                                <li>Time Saving and Money Saving.</li>
                                <li>Self Study Direct Admission Short Term Courses Only.</li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-lg-6 col-mb-6'>
                        <div className='course-inner-details pt-3'>
                            <h2 className='title-default-left title-bar-high'>छात्र कॉर्नर में आपका स्वागत है</h2>
                            <h3 className='sidebar-title'>आईटीटी परिषद कि ओर से स्व अध्ययन कि सुविधा शुरू कि गई है</h3>
                            <ul className='learning-outcomes'>
                                <li>स्वयं अध्ययन केंद्र.</li>
                                <li>प्रत्यक्ष ऑनलाइन छात्र प्रवेश.</li>
                                <li>ऑनलाइन अध्ययन केंद्र सुविधा.</li>
                                <li>ब्लॉग स्व अध्ययन और नोट्स सुविधा.</li>
                                <li>ऑनलाइन परीक्षा सुविधा.</li>
                                <li>त्वरित परिणाम.</li>
                                <li>eMail द्वारा प्रमाणपत्र भेजने की सुविधा .</li>
                                <li>समय की बचत और धन की बचत.</li>
                                <li>स्वयं अध्ययन डायरेक्ट एडमिशन केवल शॉर्ट टर्म कोर्स .</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <div className='container'>
                <div className='row mt-5 mb-4'>
                    <div className='col-md-4 col-sm-4 col-lg-4 col-xs-12 hvr-float-shadow '>
                        <div className='sidebar'>
                            <div className='sidebar-box'>
                                <div className='sidebar-box-inner'>
                                    <h3 className='sidebar-title'>Update News For Online Study Center</h3>
                                    <div className='sidebar-course-price'>
                                        <marquee behavior='scroll' direction='up' height='200xpl' scrollamount='5'>
                                            <ul className='learning-outcomes'>
                                                <li>Tally Hindi Tutorial.</li>
                                                <li>MS Office Hindi Tutorial.</li>
                                                <li>Pagemaker Hindi Tutorial.</li>
                                                <li>Photoshop Hindi Tutorial.</li>
                                                <li>Coreldraw Hindi Tutorial.</li>
                                                <li>HTML Hindi Tutorial.</li>
                                                <li>More Hindi Tutorial .</li>
                                                <li>Coming Soon .</li>
                                            </ul>
                                        </marquee>
                                        <div className='form-group'>
                                            <Link to='https://www.youtube.com/channel/UCAEonaUaC94gUq6vXneAlSg?view_as=subscriber' target='_blank'>
                                                <button className='default-full-width-btn mt-3'>View Video Tutorial</button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-4 col-sm-4 col-lg-4 col-xs-12 hvr-float-shadow '>
                        <div className='sidebar'>
                            <div className='sidebar-box'>
                                <div className='sidebar-box-inner'>
                                    <h3 className='sidebar-title'>Courses</h3>
                                    <div className='sidebar-course-price'>
                                        <marquee direction='down' height='150xpl' scrollamount='10'>
                                            <ul className='learning-outcomes'>
                                                <img src='/images/Stud_Regis_img/1.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/2.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/3.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/4.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/5.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/6.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/7.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/8.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/9.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/10.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/11.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/12.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/13.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/14.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/15.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/16.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/17.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/18.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/19.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/20.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/21.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/22.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/23.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/24.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/25.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/26.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/27.jpg' alt='image1' width='100%' />
                                            </ul>
                                        </marquee>


                                        <marquee behavior='scroll' direction='up' height='150xpl' scrollamount='10'>
                                            <ul className='learning-outcomes'>
                                                <img src='/images/Stud_Regis_img/1.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/2.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/3.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/4.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/5.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/6.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/7.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/8.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/9.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/10.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/11.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/12.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/13.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/14.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/15.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/16.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/17.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/18.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/19.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/20.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/21.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/22.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/23.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/24.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/25.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/26.jpg' alt='image1' width='100%' />
                                                <img src='/images/Stud_Regis_img/27.jpg' alt='image1' width='100%' />
                                            </ul>
                                        </marquee>
                                        <div className='form-group'>
                                            <Link to='/allcourses'>
                                                <button className='default-full-width-btn mt-3'>View Direct Addmission Course List</button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-4 col-sm-4 col-lg-4 col-xs-12 hvr-float-shadow '>
                        <div className='sidebar'>
                            <div className='sidebar-box'>
                                <div className='sidebar-box-inner'>
                                    <h3 className='sidebar-title'>Asked Any Question?</h3>
                                    <div className='sidebar-question-form'>
                                        <form>
                                            <fieldset>
                                                <div className='form-group'>
                                                    <input type='text' placeholder='Name' className='form-control' name='name' id='form-name' required={true} />
                                                    <div className='help-block with-errors'></div>
                                                </div>

                                                <div className='form-group'>
                                                    <input type='number' placeholder='Contact Number' className='form-control' name='contact number' id='form-name' required={true} />
                                                    <div className='help-block with-errors'></div>
                                                </div>

                                                <div className='form-group'>
                                                    <input type='email' placeholder='Email' className='form-control' name='email' id='form-name' required={true} />
                                                    <div className='help-block with-errors'></div>
                                                </div>
                                                <div className='form-group'>
                                                    <input type='text' placeholder='City' className='form-control' name='city' id='form-name' required={true} />
                                                    <div className='help-block with-errors'></div>
                                                </div>
                                                <div className='form-group'>
                                                    <textarea placeholder='Message' className='form-control' name='message' id='sidebar-form-message' rows={3} column={20} required={true} />
                                                    <div className='help-block with-errors'></div>
                                                </div>
                                            </fieldset>
                                        </form>

                                        <div className='form-group'>
                                            <button type='submit' class="default-full-width-btn mt-3">Send</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default StudentRegistration